// extracted by mini-css-extract-plugin
export var container = "_50-0";
export var infoButton = "_50-1";
export var label = "_50-3";
export var labelExpanded = "_50-4";
export var price = "_50-5";
export var priceExpanded = "_50-6";
export var title = "_50-2";